module.exports = __webpack_public_path__ + "img/sceneca_2.6ab56a07.png";